import { render, staticRenderFns } from "./BookingConfigurationSlots.vue?vue&type=template&id=20e54bdb"
import script from "./BookingConfigurationSlots.vue?vue&type=script&lang=ts"
export * from "./BookingConfigurationSlots.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports